import { useRecoilValue } from "recoil";
import { allPagesState } from "../storage/app";

export function usePages() {
  const allPages = useRecoilValue(allPagesState);

  const getPageTitle = (pageId: string) => {
    return allPages.find((page) => page.id === pageId)?.name;
  };
  
  const getPageNavKey = (pageId: string) => {
    return allPages.find((page) => page.id === pageId)?.navKey;
  };
  
  const getPageRouteByNavKey = (navKey?: string) => {
    return allPages.find((page) => page.navKey === navKey)?.route;
  };
  
  const getPageRoute = (id: string) => {
    return allPages.find((page) => page.id === id)?.route;
  };
  
  const getPageIdByPanelKeyRoute = (panelKeyRoute: string) => {
    return allPages.find((page) => page.route === panelKeyRoute)?.id
  }

  const getPanelUrlByNavKey = (navKey?: string) => {
    return allPages.find((page) => page.navKey === navKey)?.panelUrl ?? '';
  };

  return { 
    allPages, 
    getPageTitle, 
    getPageNavKey, 
    getPageRouteByNavKey, 
    getPageRoute, 
    getPageIdByPanelKeyRoute,
    getPanelUrlByNavKey
  };
}